export default __webpack_public_path__ + "static/media/bz.0cf46cf0.jpg";